// ------------------
// Imports
// ------------------
import { h, reactive } from 'vue';
import { event } from 'vue-gtag';
// ------------------
// Helpers
// ------------------
function display(value) {
    return {
        display: value ? '' : 'none',
    };
}
// ------------------
// State
// ------------------
const State = reactive({
    opened: [],
    active: -1,
});
// ------------------
// Popup
// ------------------
const Popup = {
    show(key, props) {
        return new Promise((resolve) => {
            State.active = State.opened.push({ key, props, resolve }) - 1;
            event('popup_display', { id: key });
        });
    },
    hide(param, index = State.opened.length - 1) {
        const currentPopup = State.opened[index];
        param !== undefined && currentPopup.resolve(param);
        State.opened.splice(index, 1);
        State.active = State.opened.length - 1;
        event('popup_close', { id: currentPopup.key });
    },
    clear() {
        State.active = -1;
        State.opened = [];
    },
    get isActive() {
        return State.active !== -1;
    },
    get opened() {
        return State.opened.map((o) => o.key);
    },
};
// ------------------
// Plugin
// ------------------
export const plugin = {
    install(app, options) {
        // set actions globally
        app.config.globalProperties.$popup = Popup;
        // <popup-view> component
        app.component('PopupView', {
            props: {
                tag: {
                    type: String,
                    default: 'div',
                },
            },
            render() {
                return h(this.$props.tag, // TODO
                { style: display(Popup.isActive) }, State.opened.map((popup, index) => {
                    return h(options.popups[popup.key], {
                        ...popup.props,
                        style: display(index === State.active),
                    });
                }));
            },
        });
    },
};
// ------------------
// Exports
// ------------------
export default Popup;
